import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderOpenOutlinedSvg from "@ant-design/icons-svg/es/asn/FolderOpenOutlined";
import AntdIcon from '../components/AntdIcon';
var FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FolderOpenOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FolderOpenOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FolderOpenOutlined';
}
export default RefIcon;